import serialize from '../utilities/serialize'

/**
 * 
 * @param fn 序列化了参数作为key，存到了result这个对象里
 * @param getKey  根据 fn 的参数设置key
 * @description 接受一个函数，返回带有缓存功能的新函数，新函数会根据参数缓存执行的结果并返回
 * 
 * @example  let add = memory((a : number,b : number)=> a + b); add(1,2); add(1,2) 第二次执行来源于缓存
 * 
 */
export default function memory<T extends (...args : any[])=> any>(fn :  T,getKey? : (...params :  Parameters<T>)=> string ) : T{
	const results : Record<string,ReturnType<T>> = {}
	function newFn(this : unknown, ...args : any[]) : ReturnType<T>{
		//args：发送给后台的参数，serialize：将args处理成key，key为字符串，是一个参数字符串
		const key = getKey ? getKey.apply(null,args as  Parameters<T>) : serialize(args)
		//将新的key存到results对象中
		if(!(key in results)){
			results[key as string] = fn.apply(this,args)
		}
		return results[key as string]
	}
	return newFn as T
}